export default "__VITE_ASSET__Bi1_b4MI__"